import { gql, useQuery } from '@apollo/client';
import React from 'react';

import { Loading } from 'src/components/common/loading/Loading';
import { NotFound } from 'src/components/common/notFound/NotFound';
import { ErrorMessage } from 'src/components/errorMessage/ErrorMessage';
import { GraphQLTypes } from 'src/lib/graphqlTypes';

import { useGraphRef } from '../hooks/useGraphRef';

import { ExplorerSettingsCard } from './explorerSettingsCard/ExplorerSettingsCard';

const VariantExplorerSettingsQuery = gql`
  query VariantSettings__ExplorerPage($graphId: ID!, $graphVariant: String!) {
    graph: service(id: $graphId) {
      id
      title
      graphType
      account {
        id
      }
      schemaTag(tag: $graphVariant) {
        id
      }
      variant(name: $graphVariant) {
        url
        id
        subscriptionUrl
        sendCookies
      }
    }
  }
`;
export const VariantExplorerSettingsPage = () => {
  const graphRef = useGraphRef();
  const { data, loading, error } = useQuery<
    GraphQLTypes.VariantSettings__ExplorerPage,
    GraphQLTypes.VariantSettings__ExplorerPageVariables
  >(VariantExplorerSettingsQuery, {
    variables: {
      graphId: graphRef?.graphId || '',
      graphVariant: graphRef?.graphVariant || '',
    },
  });

  const isCloudSupergraph =
    data?.graph?.graphType === GraphQLTypes.GraphType.CLOUD_SUPERGRAPH;

  if (loading) return <Loading />;

  if (error) <ErrorMessage error={error} />;

  if (!data?.graph || !data.graph.variant) return <NotFound />;

  return (
    <ExplorerSettingsCard
      currentVariant={data.graph.variant}
      isFirstPublish={!data.graph.schemaTag}
      isCloudSupergraph={isCloudSupergraph}
    />
  );
};
